/** 银企直连 bankJournal 模块（BankJournalTenantTab / JournalAuditDialog / RefundDialog / BankJournalHighFilter） */
export default {
  bankJournalPage: {
    confirmTitle: '提示',
    confirmOk: '确定',
    confirmCancel: '取消',
    confirmApprove: '确认通过?',
    phDateStart: '开始时间',
    phDateEnd: '结束时间',
    phTenant: '租户名称/编号',
    phStatus: '状态',
    phBankType: '银行类型',
    phSelect: '请选择',
    phInput: '请输入',
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    sectionTenantTitle: '银企直连 · 租户充值',
    sortDefault: '默认排序',
    colSeqNo: '交易流水号',
    colPayeeName: '汇款账户',
    colBankNumber: '汇款账号',
    colAmountYuan: '金额(元)',
    colReceivAccount: '收款企业',
    colReceivAccountNum: '收款账号',
    colOpeningBank: '开户银行',
    colRecvBank: '收款银行',
    colRemark: '汇款备注',
    colTenantId: '租户ID',
    colTenantName: '租户名称',
    colTime: '时间',
    colType: '交易类型',
    colStatus: '状态',
    colAction: '操作',
    btnProcess: '处理',
    btnVoid: '作废',
    msgLoadFail: '加载失败',
    msgConfirmVoid: '确认更改作废?',
    msgVoidOk: '已作废',
    msgNoExportData: '无数据可导出',
    exportSheetName: '租户充值',
    exportFilePrefixCurrentPage: '租户充值_本页',
    bankBankOfChina: '中国银行',
    bankPufa: '浦发银行',
    bankBocDigital: '中国银行数字科技',
    bankCmb: '招商银行',
    bankNbAsset: '宁波银行资产大管家',
    statusPending: '未处理',
    statusDone: '已完成',
    statusVoided: '已作废',
    statusRefunding: '退款中',
    statusRefunded: '已退款',
    typeCharge: '充值',
    typeRefund: '退款',
    dialogAuditTitle: '处理',
    lblPayeeName: '汇款账户',
    lblBankNumber: '汇款账号',
    lblAmountYuan: '打款金额(元)',
    lblSeqNo: '交易流水号',
    lblTenantPick: '租户名称/编号',
    phSearchTenant: '请选择或搜索租户',
    bizPickTitle: '请选择入账专户',
    bizPickDesc: '该租户同时开通了{electric}与{water}。请根据本次汇款性质，点击下面其中一张卡片选择入账方向；默认选中电费，可改选水费后再点「确认」。',
    accountElectricLedger: '电费专户',
    accountWaterLedger: '水费专户',
    cardElectricDesc: '适用于电表预付费、电费余额等场景',
    cardWaterDesc: '适用于水表预付费、水费余额等场景',
    rechargeTypeTitle: '充值类型',
    singleMeterOnly: '该租户仅有「电费专户」，本次款项将入账至电费账户。',
    singleWaterOnly: '该租户仅有「水费专户」，本次款项将入账至水费账户。',
    alertNoMeterWaterAccount: '该租户未查询到电费或水费专户信息，请确认租户资料后再处理。',
    selectTenantFirstHint: '请先在上方下拉中选择租户',
    btnCancel: '取消',
    btnConfirm: '确认',
    msgBankMatchFail: '获取匹配租户失败',
    msgTenantWalletFail: '获取租户专户信息失败',
    msgPickTenant: '请选择租户',
    msgNoWalletBook: '该租户无电费/水费专户，无法入账',
    msgPickRechargeType: '请选择充值类型',
    msgOpSuccess: '操作成功',
    dialogRefundTitle: '对公充值退款',
    lblRefundAmount: '退款金额(元)',
    lblRecvAccount: '收款账户',
    lblRecvAccountNum: '收款账号',
    lblPayoutDate: '打款日期',
    lblRefundReason: '退款事由',
    btnFeishuSubmit: '发起飞书审核',
    rulePayoutDate: '请选择打款日期',
    ruleRefundReason: '请输入退款事由',
    msgFeishuApplyFail: '飞书申请失败',
    msgSubmitted: '已提交',
    drawerAdvancedFilter: '高级筛选',
    lblTenantNameNo: '租户名称/编号',
    phTenantNameOrNo: '租户名称或编号',
    lblRecvSubAccount: '收款账号',
    lblRemitterAccount: '汇款账户',
    lblRemitterBankNo: '汇款账号',
    lblState: '状态',
    lblBankKind: '银行类型',
    lblDateRange: '日期'
  }
}
